/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as NewRouteRouteImport } from './routes/new/route'
import { Route as oldRouteRouteImport } from './routes/(old)/route'
import { Route as NewIndexRouteImport } from './routes/new/index'
import { Route as NewPreSeasonIndexRouteImport } from './routes/new/pre-season/index'
import { Route as NewInSeasonIndexRouteImport } from './routes/new/in-season/index'
import { Route as oldInSeasonIndexRouteImport } from './routes/(old)/in-season/index'
import { Route as oldProductProductIdLocationsRouteImport } from './routes/(old)/product/$productId/locations'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const NewRouteRoute = NewRouteRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const oldRouteRoute = oldRouteRouteImport.update({
  id: '/(old)',
  getParentRoute: () => rootRouteImport,
} as any)
const NewIndexRoute = NewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => NewRouteRoute,
} as any)
const NewPreSeasonIndexRoute = NewPreSeasonIndexRouteImport.update({
  id: '/pre-season/',
  path: '/pre-season/',
  getParentRoute: () => NewRouteRoute,
} as any)
const NewInSeasonIndexRoute = NewInSeasonIndexRouteImport.update({
  id: '/in-season/',
  path: '/in-season/',
  getParentRoute: () => NewRouteRoute,
} as any)
const oldInSeasonIndexRoute = oldInSeasonIndexRouteImport.update({
  id: '/in-season/',
  path: '/in-season/',
  getParentRoute: () => oldRouteRoute,
} as any)
const oldProductProductIdLocationsRoute =
  oldProductProductIdLocationsRouteImport.update({
    id: '/product/$productId/locations',
    path: '/product/$productId/locations',
    getParentRoute: () => oldRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/new': typeof NewRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/new/': typeof NewIndexRoute
  '/in-season': typeof oldInSeasonIndexRoute
  '/new/in-season': typeof NewInSeasonIndexRoute
  '/new/pre-season': typeof NewPreSeasonIndexRoute
  '/product/$productId/locations': typeof oldProductProductIdLocationsRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/new': typeof NewIndexRoute
  '/in-season': typeof oldInSeasonIndexRoute
  '/new/in-season': typeof NewInSeasonIndexRoute
  '/new/pre-season': typeof NewPreSeasonIndexRoute
  '/product/$productId/locations': typeof oldProductProductIdLocationsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(old)': typeof oldRouteRouteWithChildren
  '/new': typeof NewRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/new/': typeof NewIndexRoute
  '/(old)/in-season/': typeof oldInSeasonIndexRoute
  '/new/in-season/': typeof NewInSeasonIndexRoute
  '/new/pre-season/': typeof NewPreSeasonIndexRoute
  '/(old)/product/$productId/locations': typeof oldProductProductIdLocationsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/new'
    | '/$'
    | '/new/'
    | '/in-season'
    | '/new/in-season'
    | '/new/pre-season'
    | '/product/$productId/locations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/new'
    | '/in-season'
    | '/new/in-season'
    | '/new/pre-season'
    | '/product/$productId/locations'
  id:
    | '__root__'
    | '/(old)'
    | '/new'
    | '/$'
    | '/new/'
    | '/(old)/in-season/'
    | '/new/in-season/'
    | '/new/pre-season/'
    | '/(old)/product/$productId/locations'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  oldRouteRoute: typeof oldRouteRouteWithChildren
  NewRouteRoute: typeof NewRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(old)': {
      id: '/(old)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof oldRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new/': {
      id: '/new/'
      path: '/'
      fullPath: '/new/'
      preLoaderRoute: typeof NewIndexRouteImport
      parentRoute: typeof NewRouteRoute
    }
    '/new/pre-season/': {
      id: '/new/pre-season/'
      path: '/pre-season'
      fullPath: '/new/pre-season'
      preLoaderRoute: typeof NewPreSeasonIndexRouteImport
      parentRoute: typeof NewRouteRoute
    }
    '/new/in-season/': {
      id: '/new/in-season/'
      path: '/in-season'
      fullPath: '/new/in-season'
      preLoaderRoute: typeof NewInSeasonIndexRouteImport
      parentRoute: typeof NewRouteRoute
    }
    '/(old)/in-season/': {
      id: '/(old)/in-season/'
      path: '/in-season'
      fullPath: '/in-season'
      preLoaderRoute: typeof oldInSeasonIndexRouteImport
      parentRoute: typeof oldRouteRoute
    }
    '/(old)/product/$productId/locations': {
      id: '/(old)/product/$productId/locations'
      path: '/product/$productId/locations'
      fullPath: '/product/$productId/locations'
      preLoaderRoute: typeof oldProductProductIdLocationsRouteImport
      parentRoute: typeof oldRouteRoute
    }
  }
}

interface oldRouteRouteChildren {
  oldInSeasonIndexRoute: typeof oldInSeasonIndexRoute
  oldProductProductIdLocationsRoute: typeof oldProductProductIdLocationsRoute
}

const oldRouteRouteChildren: oldRouteRouteChildren = {
  oldInSeasonIndexRoute: oldInSeasonIndexRoute,
  oldProductProductIdLocationsRoute: oldProductProductIdLocationsRoute,
}

const oldRouteRouteWithChildren = oldRouteRoute._addFileChildren(
  oldRouteRouteChildren,
)

interface NewRouteRouteChildren {
  NewIndexRoute: typeof NewIndexRoute
  NewInSeasonIndexRoute: typeof NewInSeasonIndexRoute
  NewPreSeasonIndexRoute: typeof NewPreSeasonIndexRoute
}

const NewRouteRouteChildren: NewRouteRouteChildren = {
  NewIndexRoute: NewIndexRoute,
  NewInSeasonIndexRoute: NewInSeasonIndexRoute,
  NewPreSeasonIndexRoute: NewPreSeasonIndexRoute,
}

const NewRouteRouteWithChildren = NewRouteRoute._addFileChildren(
  NewRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  oldRouteRoute: oldRouteRouteWithChildren,
  NewRouteRoute: NewRouteRouteWithChildren,
  SplatRoute: SplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
